import { rem } from '@nobia/zeus-components/lib/styled'

export default {
  colors: {
    text: '#424242',
    specialText: '#858585',
    grayText: '#424242',
  },
  typography: {
    pageTitle: {
      fontFamily: '"Tahoma", Arial, Helvetica, sans-serif',
      fontSize: rem(36),
      fontSizeDesktop: rem(36),
      fontWeight: '300',
      textTransform: 'uppercase',
    },
    subHeadline: {
      fontWeight: '700',
      letterSpacing: '0.6px',
      letterSpacingDesktop: '0.6px',
    },
    pageDescription: {
      fontSizeDesktop: rem(16),
    },
    collectionLabel: {
      fontSize: rem(18),
      letterSpacing: '0.6px',
    },
    imageLabelText: {
      fontSize: rem(16),
    },
    modalHeadline: {
      fontWeight: '300',
      textTransform: 'uppercase',
      fontSizeDesktop: rem(60),
    },
    modalText: {
      fontSize: rem(16),
    },
    mobileImageLabel: {
      fontSize: rem(21),
    },
    mobileImageLink: {
      fontSize: rem(16),
    },
  },
}
